import * as React from 'react';
// constants
import { TEXT_KEYS } from './invitee.constants';
import { TEXT_KEYS as TEXT_KEYS_INVITEE } from '../../invitee/invitee.constants';
import { DASHBOARD_PAGE_STATUS_KEY } from '@sitegen/common/constants/translations';
// assets
import arrowDown from '../../../assets/arrow-down.svg';
// types
import { IInviteeProps, IInviteeStateProps } from './invitee.types';
// styles
import './invitee.styles.less';
// utils
import { translate } from 'components/translate-hoc';
import { getConjunctionType, getRulesStatuses } from '../../invitee/invitee.utils';
import { CONJUNCTION_TYPES } from '@sitegen/common/classes/friends-referral-api';
import { generateTranslationsKeyById } from '@sitegen/common/utils/translations';
import { getModeClass } from 'utils/css';

export class Invitee extends React.Component<IInviteeProps, IInviteeStateProps> {
    public state: IInviteeStateProps = {
        open: false,
        isLoading: true
    };

    public async componentDidMount() {
        const { playerInfo, updateInvitationInfo } = this.props;
        await updateInvitationInfo({
            referrerUbiAccountId: playerInfo.referrerUbiAccountId!,
            platformId: playerInfo.platformId!
        });
        this.setState({ isLoading: false });
    }

    public handleDropDownState = (): void => {
        this.setState(prevState => ({ open: !prevState.open }));
    };

    public renderRewardImage(): JSX.Element | null {
        const { inviteeRewardImageSrc, shouldInheritStyles } = this.props;
        const basePageStyleClass = getModeClass('sitegen-friend-referral-dashboard-page-invitee', shouldInheritStyles);
        return (
            <div className={`${basePageStyleClass}__reward__image`}>
                <img src={inviteeRewardImageSrc} alt=""/>
            </div>
        );
    }

    public getConjunctionText = (conjunctionType: CONJUNCTION_TYPES) => {
        return conjunctionType === CONJUNCTION_TYPES.AND
            ? TEXT_KEYS_INVITEE.CONJUNCTION_AND_TEXT
            : TEXT_KEYS_INVITEE.CONJUNCTION_OR_TEXT;
    };

    public renderRulesDescription = (): JSX.Element[] => {
        const {
            conversion: { rules, conjunction },
            dangerouslyTranslateWithHTML: translateKey,
            playerStats,
            invitationInfo,
            dataFormat,
            shouldInheritStyles
        } = this.props;
        const conjunctionType = getConjunctionType(conjunction);
        const conjunctionText = this.getConjunctionText(conjunctionType);
        const statusesDescriptions = getRulesStatuses(rules, playerStats, invitationInfo, dataFormat);
        const basePageStyleClass = getModeClass('sitegen-friend-referral-dashboard-page-invitee', shouldInheritStyles);
        return statusesDescriptions.map((status, index) => (
            <div key={index} className={`${basePageStyleClass}__status`}>
                {translateKey(
                    generateTranslationsKeyById(DASHBOARD_PAGE_STATUS_KEY, status.id),
                    {
                        statValue: status.statValue,
                        username: status.username,
                        paramThreshold: status.paramThreshold
                    }
                )}
                {index < statusesDescriptions.length - 1
                    ? <div className={`${basePageStyleClass}__content-conjunction`}>
                        <div className="conjunction-text">
                            {translateKey(conjunctionText)}
                        </div>
                    </div>
                    : null
                }
            </div>
        ));
    };

    public render(): JSX.Element | null {
        const { open, isLoading } = this.state;
        const {
            dangerouslyTranslateWithHTML: translateKey,
            inviteeRewardImageSrc,
            shouldInheritStyles
        } = this.props;

        if (isLoading) {
            return null;
        }

        const rewardDescription = translateKey(TEXT_KEYS.REWARD_DESCRIPTION);
        const basePageStyleClass = getModeClass('sitegen-friend-referral-dashboard-page-invitee', shouldInheritStyles);

        return (
            <div className={basePageStyleClass}>
                <div className={`${basePageStyleClass}__wrapper ${open && 'open'}`}>
                    <div className={`${basePageStyleClass}__container`}>
                        <div>
                            {this.renderRulesDescription()}
                        </div>
                        <img src={arrowDown} alt="" onClick={this.handleDropDownState} />
                    </div>
                    {open ? (
                        <div className={`${basePageStyleClass}__reward`}>
                            {inviteeRewardImageSrc ? this.renderRewardImage() : null}
                            <div className={`${basePageStyleClass}__reward__description`}>
                                {rewardDescription}
                            </div>
                        </div>
                    ) : null}
                </div>
            </div>
        );
    }
}

export default translate()(Invitee);
